module.exports = __webpack_public_path__ + "5ff896076c72f04a18737cb84f242e63.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/mythosgoldencity.jpg
// module id = 776
// module chunks = 0